import { RootState } from '@app/redux/root-reducer';

export const selectLoginState = (store: RootState) => store.authReducer.login;

export const selectSignUpState = (store: RootState) => store.authReducer.signUp;

export const selectForgotPasswordState = (store: RootState) => store.authReducer.forgotPassword;

export const selectSetPasswordState = (store: RootState) => store.authReducer.setPassword;
